import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import moment from "moment";
import ScrollSync from "vue-scroll-sync";
import { IReceptionDay, IReception, AppointmentStatus, ReceptionType, IOtherAppointmentSlot, IReceptionSlot, IPermission } from "@/models";
import DatePicker from "vue2-datepicker";
import { OtherAppointmentEdit } from "@/components";

@Component({
    name: "receptionday",
    components: {
        "scroll-sync": ScrollSync,
        "datepicker": DatePicker,
        "otherappointment-edit": OtherAppointmentEdit,
    },
})

export default class ReceptionDay extends Vue {
    public showEditMeetingModal: boolean = false;

    public currentDryMaterial: IReceptionSlot;
    public currentGlassware: IReceptionSlot;

    public occurrence: number;

    public constructor() {
        super();
    }

    // LOGIC
    public get notBefore(): Date {
        return moment().hours(0).minutes(0).toDate();
    }

    public get receptionDay(): IReceptionDay {
        return this.$store.getters["receptions/getReceptionDay"]();
    }

    public get otherAppointments(): IOtherAppointmentSlot[] {
        if (this.receptionDay) {
            return this.$store.getters["otherAppointments/getOtherAppointmentByDays"](this.receptionDay.day);
        }
        return this.$store.getters["otherAppointments/getOtherAppointments"]();
    }

    public get dryMaterials(): IReceptionSlot[] {
        return this.receptionDay.dryMaterials;
    }

    public get glasswares(): IReceptionSlot[] {
        return this.receptionDay.glasswares;
    }

    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public get startSlotId(): number {
        return this.$store.state.receptions.receptionStartSlot.slotId;
    }

    public get startHour(): number {
        return moment(this.$store.state.receptions.receptionStartSlot.startTime, "HH:mm:ss").hour();
    }

    public get startMinute(): number {
        return moment(this.$store.state.receptions.receptionStartSlot.startTime, "HH:mm:ss").minute();
    }

    public get endSlotId(): number {
        return this.$store.state.receptions.receptionEndSlot.slotId;
    }

    public get slotCount(): number {
        return this.endSlotId - this.startSlotId + 1;
    }

    public lookupOtherAppointment(slotId: number): boolean {
        slotId += this.startSlotId; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        return this.otherAppointments.some(x => x.slotId === slotId);
    }

    public lookupDryMaterials(slotId: number): boolean {
        slotId += this.startSlotId; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        return this.dryMaterials.some(x => x.slotId === slotId);
    }

    public lookupGlasswares(slotId: number): boolean {
        slotId += this.startSlotId; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        return this.glasswares.some(x => x.slotId === slotId);
    }

    public lookupCurrentDryMaterial(index: number): boolean {
        if (this.currentDryMaterial != null && this.occurrence < 2) {
            this.occurrence++;
            return true;
        }
        else {
            return false;
        }
    }

    public lookupCurrentGlassware(): boolean {
        if (this.currentGlassware != null && this.occurrence < 2) {
            this.occurrence++;
            return true;
        }
        else {
            return false;
        }
    }

    public getDryMaterial(slotId: number): IReceptionSlot {
        slotId += this.startSlotId; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        this.occurrence = 0;
        this.currentDryMaterial = this.dryMaterials.find(x => x.slotId === slotId);

        return this.currentDryMaterial;
    }

    public getGlassware(slotId: number): IReceptionSlot {
        slotId += this.startSlotId; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        this.occurrence = 0;
        this.currentGlassware = this.glasswares.find(x => x.slotId === slotId);
        return this.currentGlassware;
    }

    public getOtherAppointment(slotId: number): IOtherAppointmentSlot {
        slotId += this.startSlotId;

        return this.otherAppointments.find(x => x.slotId === slotId);
    }

    public openEditMeetingModal(meeting: IOtherAppointmentSlot) {
        this.$store.commit("otherAppointments/SET_SELECTED_OTHER_APPOINTMENT", meeting);

        this.showEditMeetingModal = true;
    }

    // DESIGN AND NAVIGATION

    public designStatus(slotId: number, type: ReceptionType): string {
        let receptionSlot: IReceptionSlot;
        let classes: string = "";

        if (type === ReceptionType.DryMaterials) {
            receptionSlot = this.getDryMaterial(slotId);
        }
        else {
            receptionSlot = this.getGlassware(slotId);
        }

        const timeCell = moment().hour(this.startHour).minute(this.startMinute).add(15 * (slotId + 1), "m"); // start time at 5:30

        if (receptionSlot != null) {
            const status = receptionSlot.reception.status;

            if (status === AppointmentStatus.Cancel) {
                classes += "cancel blocked ";
            }
            else if (status === AppointmentStatus.InProgress || status === AppointmentStatus.Unexpected) {
                classes += "in-progress ";
            }
            else if (status === AppointmentStatus.Done) {
                classes += "done ";
            }
        }

        if (moment(this.receptionDay.day).isSame(moment().hour(0).minute(0).second(0), "day")) {
            if (moment().diff(timeCell) > 0) {
                if (receptionSlot != null && (receptionSlot.reception.status === AppointmentStatus.Waiting || receptionSlot.reception.status === AppointmentStatus.Unexpected)) {
                    classes += "passed waiting";
                } else {
                    classes += "passed ";
                }
            }
        }

        return classes;
    }

    public getCurrentDesign(slotId: number, type: number): string {
        let classes: string = "";
        if (moment(this.receptionDay.day).isSame(moment(), "day")) {
            const time = moment().hour(this.startHour).minute(this.startMinute).add(15 * (slotId + 1 - this.occurrence), "m");

            if (type === 1) {
                if (moment().diff(time) > 0 && this.currentDryMaterial.reception.status === AppointmentStatus.Waiting) {
                    classes += "passed waiting ";
                }
                else if (this.currentDryMaterial.reception.status === AppointmentStatus.InProgress ||
                    this.currentDryMaterial.reception.status === AppointmentStatus.Unexpected) {
                    classes += "in-progress ";
                }
                else if (this.currentDryMaterial.reception.status === AppointmentStatus.Done) {
                    classes += "done ";
                }
            }
            else {
                if (moment().diff(time) > 0 && this.currentGlassware.reception.status === AppointmentStatus.Waiting) {
                    classes += "passed waiting ";
                }
                else if (this.currentGlassware.reception.status === AppointmentStatus.InProgress ||
                    this.currentGlassware.reception.status === AppointmentStatus.Unexpected) {
                    classes += "in-progress ";
                }
                else if (this.currentGlassware.reception.status === AppointmentStatus.Done) {
                    classes += "done ";
                }
            }
        }

        classes += `class${this.occurrence}`;

        return classes;
    }

    public goDelivery(receptionType: ReceptionType, slotId: number): void {
        slotId += this.startSlotId; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        const allReception = this.receptionDay.dryMaterials.concat(this.receptionDay.glasswares);

        const reception = allReception.find(x => (x.slotId === slotId - this.occurrence || x.slotId === slotId - 1 || x.slotId === slotId - 2)
            && x.reception.type === receptionType).reception;

        this.$store.commit("receptions/SET_SELECTED_RECEPTION", reception);

        this.$router.push({ name: "receptionDetail" });
    }

    public goNew(index: number, type: ReceptionType) {
        const time = moment().hour(this.startHour).minute(this.startMinute).add(15 * (index), "m");

        const datetime = moment(this.receptionDay.day);
        datetime.hour(time.get("h"));
        datetime.minute(time.get("m"));

        this.$router.push({ name: "receptionCreate", query: { datetime: datetime.format("YYYY-MM-DD HH:mm"), type: type.toString() } });
    }

    public eventOtherAppoinement(event: any): void {
        this.showEditMeetingModal = false;
    }
}
